export const propsToDisplay = {
  shippingPolicyText: 'shipping',
  paymentPolicyText: 'payment',
  returnPolicyText: 'returns',
};
